export type Notification = {
    message: string;
    alwaysDisplayed: boolean;
};

export type NotificationOrNull = Notification | null;

export const NotificationPortalType = {
    All: 'ALL',
    OwnerPortal: 'OWNER_PORTAL',
    UserPortal: 'USER_PORTAL',
    EmbeddedPortal: 'EMBEDDED_PORTAL',
} as const;
